import {
    Body as AccordionBody,
    Header as AccordionHeader,
    Title as AccordionTitle,
    Wrapper as AccordionWrapper,
} from '@r1-frontend/ui-react/components/accordions/Accordion';
import { TTheme } from '@r1-frontend/ui-react/components/accordions/Accordion/themes';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';
import { useModal } from '@r1-frontend/shared/hooks/useModal';

import * as ST from './styled';

const theme: TTheme = {
    border: COLORS.BgSurface,
    background: COLORS.BgSurface,
    radius: BorderRadius.InnerBlockRadius,
    padding: '24px',
    mobilePadding: '12px 16px',
    storyColor: COLORS.BgMain,
    color: COLORS.TextPrimary,

    colorArrow: COLORS.GRAY_DARK,
    colorArrowIsOpen: COLORS.GRAY_DARK,

    buttonType: 'secondary',

    backgroundIcon: COLORS.ButtonSecondary,
    borderIcon: COLORS.ButtonSecondary,
    backgroundIconIsOpen: COLORS.ButtonSecondary,
    borderIconIsOpen: COLORS.ButtonSecondary,
};

/**
 * Инструкция по оплате с помощью СберПэй
 */
export const SberPayInstruction = (): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    const { isOpen, toggleModal: toggleAccordion } = useModal();

    return (
        <AccordionWrapper
            theme={theme}
        >
            <AccordionHeader
                onOpen={toggleAccordion}
                colors={theme}
                isOpen={isMobile ? isOpen : true}
                showButton={isMobile}
            >
                <AccordionTitle itemProp={'name'}>
                    <IndentContainer $united={[0, 8, 0, 0]}>
                        <H4 $withIndent={false}>Инструкция</H4>
                    </IndentContainer>
                </AccordionTitle>
            </AccordionHeader>
            <AccordionBody
                isOpen={isMobile ? isOpen : true}
                withDividingBorder={false}
            >
                <IndentContainer $united={[8, 0]}>
                    <ST.List>
                        <ST.ListItem>
                            <Paragraph4>
                                Введите номер телефона, к&nbsp;которому привязана карта СберБанка.
                            </Paragraph4>
                        </ST.ListItem>
                        <ST.ListItem>
                            <TextWrapper $lastIndent={false}>
                                <Paragraph4>
                                    Если у&nbsp;вас Android, откройте СберБанк Онлайн по&nbsp;ссылке из&nbsp;пуш-уведомления, которой придёт вам на&nbsp;смартфон.
                                </Paragraph4>
                                <Paragraph4>
                                    Если у&nbsp;вас iOS, откройте СберБанк Онлайн и&nbsp;нажмите на&nbsp;карточку Дом.ру над разделом &laquo;Кошелёк&raquo; на&nbsp;главном экране.
                                </Paragraph4>
                            </TextWrapper>
                        </ST.ListItem>
                        <ST.ListItem>
                            <Paragraph4>
                                Подтвердите оплату.
                            </Paragraph4>
                        </ST.ListItem>
                    </ST.List>
                </IndentContainer>
            </AccordionBody>
        </AccordionWrapper>
    );
};
